import { DIENSTGRAD_CONFIG } from '../../lib/dienstgrade';
export const dienstgradOptions = [
  { group: 'Ohne Dienstgrad', options: [
    { value: 'ANGESTELLT', label: DIENSTGRAD_CONFIG.ANGESTELLT.label },
  ]},
  { group: 'Mittlerer Dienst', options: [
    { value: 'BM-A1', label: 'Brandmeisteranwärter (1. Jahr)' },
    { value: 'BM-A2', label: 'Brandmeisteranwärter (2. Jahr)' },
    { value: 'BM', label: 'Brandmeister' },
    { value: 'OBM', label: 'Oberbrandmeister' },
    { value: 'HBM', label: 'Hauptbrandmeister' },
    { value: 'HBMZ', label: 'Hauptbrandmeister m.Z.' },
  ]},
  { group: 'Gehobener Dienst', options: [
    { value: 'BI', label: 'Brandinspektor' },
    { value: 'BOI', label: 'Brandoberinspektor' },
    { value: 'BA', label: 'Brandamtmann' },
    { value: 'BAR', label: 'Brandamtsrat' },
    { value: 'BOAR', label: 'Brandoberamtsrat' },
  ]},
  { group: 'Höherer Dienst', options: [
    { value: 'BR', label: 'Brandrat' },
    { value: 'BOR', label: 'Brandoberrat' },
    { value: 'BD', label: 'Branddirektor' },
    { value: 'LTDBD', label: 'Leitender Branddirektor' },
  ]},
];

export const qualifikationOptions = [
  { value: 'RS', label: 'Rettungssanitäter' },
  { value: 'RS+', label: 'Rettungssanitäter Plus (RS+)' },
  { value: 'RSN', label: 'Rettungssanitäter (RSN)' },
  { value: 'RA', label: 'Rettungsassistent' },
  { value: 'NotSan', label: 'Notfallsanitäter' },
  { value: 'RH', label: 'Rettungshelfer' },
];

export const rolleOptions = [
  { value: 'MITARBEITER', label: 'Mitarbeiter' },
  { value: 'ADMIN', label: 'Admin' },
  { value: 'WACHABTEILUNGSLEITUNG', label: 'Wachabteilungsleitung' },
  { value: 'WACHLEITUNG_VERTRETUNG', label: 'Wachleitung (Vertretung)' },
  { value: 'WACHLEITUNG', label: 'Wachleitung' },
];
